import { tasksRepo } from '@/constants/providers';
import { ApiResponse } from '@/shared/types';
import { useMutation } from '@tanstack/react-query';

export const useDeleteTask = () =>
  useMutation<ApiResponse<unknown>, unknown, number>((id) =>
    tasksRepo.deleteTask(id),
  );
